enum SUPPORTED_ENVIRONMENT {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export default SUPPORTED_ENVIRONMENT;
